import { AuthService } from './../../_services/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
import Swal from 'sweetalert2'
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-room',
  templateUrl: './create-room.component.html',
  styleUrls: ['./create-room.component.scss']
})
export class CreateRoomComponent implements OnInit {

  form: FormGroup;
  constructor(fb: FormBuilder, private afs: AppFirestoreService, private router: Router,
    public dialogRef: MatDialogRef<CreateRoomComponent>,public auth: AuthService) {
    this.form = fb.group({
      'roomName': ['', Validators.required],
      'password': ['', Validators.required]
    })
  }

  ngOnInit() {
  }


  createRoom() {
    console.log('Creating the room...')
    Swal.showLoading();
    let room: any = {
      name: this.form.controls['roomName'].value,
      password: this.form.controls['password'].value,
      isActive: true,
      users: [],
    }

    this.afs.collection('room').add(room).then(x => {
      Swal.close();
      this.dialogRef.close();
      let id = x.id;
      this.router.navigate([]).then(result => { window.open(`jitsi/${id}`, '_blank'); });
    });


  }
}
